import axios from "axios";
// import { Toast } from "../../lib/helpers/helpers";
import API_MAP from "../../services/uri";

export const addItemToCart = async (credentials) => {
	const response = await axios.get(`${API_MAP.AddToCart}`, credentials);
	return response.data;
};

export const editShopItem = async ({ credentials }) => {
	const response = await axios.put(`${API_MAP.editShopItem}`, credentials);
	return response.data;
};

export const viewAllCart = async ({ email }) => {
	const response = await axios.get(`${API_MAP.ViewAllCart}?email=${email}`);
	return response.data;
};
export const viewSelectedWeddingCart = async ({ email, weddingId }) => {
    console.log( email, weddingId )
	const response = await axios.get(
		`${API_MAP.ViewSelectedCart}?email=${email}&weddingId=${weddingId}`
	);
	return response.data.data;
};
